BX.Vue.component('aos__kid', {
  computed: {},
  data: function () {
    return {
      id: null,
      title: '',
      html: '',
    };
  },
  methods: {
    msg: function (code) {
      return BX.aBase.msg(code);
    },
    acceptAgreement: function () {
      BX.ajax
        .runComponentAction('aton:aos', 'setKid', {
          url: location.pathname,
          mode: 'class',
          data: {
            id: this.id,
          },
        })
        .catch(function (err) {
          console.error(err);
        });

      this.$parent.step = 'SELECT_ENTER_DATA';
    },
  },
  computed: {
    btnText: (vm) => vm.$parent.msg('A_AOS_KID_BTN'),
  },
  beforeMount: function () {
    const vm = this;

    BX.ajax
      .runComponentAction('aton:aos', 'getKid', {
        url: location.pathname,
        mode: 'class',
      })
      .then(function (response) {
        if (response.status === 'success') {
          vm.id = response.data.id;
          vm.title = response.data.name;
          vm.html = response.data.text;
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  },
  template: `
          <div class="aos__kid">
            <h3 class="h3" v-if="title?.length" v-html="title" />
            <div class="aos__kid-text" v-if="html?.length" v-html="html" />
            <button class="aos__kid-button button-2024 -l" @click.prevent="acceptAgreement">{{btnText}}</button>
          </div>
        `,
});
